import { gql } from '@apollo/client';

import { ETariffType } from 'types';

export interface HostsModalsDataResponse {
  hostsOverview: Array<{
    id: number;
    alias: string;
    locked: boolean;
    group_id: number;
    in_service: boolean;
    qr: string;
    user?: {
      uuid: string;
      nickname: string;
      phone: string;
      avatar_url: string;
      roles: {
        alias: string;
      }[];
    };

    client_sessions: Array<
      | {
          id: number;
          postpaid: boolean;
          seances: {
            tariff: {
              kind: ETariffType;
            };
          }[];
        }
      | undefined
    >;
    bookings: Array<{
      id: number;
    }>;
  }>;
  hostGroupsOverview: {
    id: number;
    title: string;
  }[];
}
export const HOST_MODALS_DATA = gql`
  query hostsModalsData {
    hostsOverview {
      id
      alias
      locked
      group_id
      in_service
      qr
      user {
        uuid
        nickname
        phone
        avatar_url
        roles {
          alias
        }
      }

      client_sessions {
        id
        postpaid
        seances {
          tariff {
            kind
          }
        }
      }
      bookings {
        id
      }
    }
    hostGroupsOverview {
      id
      title
    }
  }
`;
